import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { tourHasPreContract } from "../constants/tourPreContract";

export default function PreContractInfo() {
  const { tourKey } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const preContractKey =
    tourKey === "madrid-lipanj-dva-termina"
      ? "madrid-segovia"
      : tourKey;

  if (!tourHasPreContract(tourKey)) {
    navigate("/blog");
    return null;
  }

  return (
    <div className="app">
      <Navbar />
      <main>
        <section className="section" style={{ paddingTop: "6rem" }}>
          <div className="container">
            <button
              type="button"
              className="btn-page-back"
              onClick={() => navigate(`/tour/${tourKey}`)}
            >
              ← {t("tourDetail.btnBack") || "Vrati nazad"}
            </button>

            <article className="pre-contract-info">
              <h1 style={{ marginBottom: "2rem", color: "#f97316", fontSize: "2rem" }}>
                {t(`preContract.${preContractKey}.title`)}
              </h1>

              <h2
                style={{
                  marginBottom: "1rem",
                  fontSize: "1.25rem",
                  fontWeight: 600,
                  color: "#111827",
                }}
              >
                {t("tourDetail.packagePreContractSection")}
              </h2>
              <div
                style={{
                  marginBottom: "2.5rem",
                  padding: "2rem",
                  background: "#fafafa",
                  borderRadius: "0.75rem",
                  border: "1px solid rgba(0, 0, 0, 0.08)",
                  fontSize: "0.95rem",
                  lineHeight: "1.8",
                  color: "#111827",
                  whiteSpace: "pre-wrap",
                }}
              >
                {t(`preContract.${preContractKey}.content`, { returnObjects: true })}
              </div>

              <h2
                style={{
                  marginBottom: "1rem",
                  fontSize: "1.25rem",
                  fontWeight: 600,
                  color: "#111827",
                }}
              >
                {t("termsOfTravel.title")}
              </h2>
              <div
                style={{
                  padding: "2rem",
                  background: "#fafafa",
                  borderRadius: "0.75rem",
                  border: "1px solid rgba(0, 0, 0, 0.08)",
                  fontSize: "0.95rem",
                  lineHeight: "1.8",
                  color: "#111827",
                  whiteSpace: "pre-wrap",
                }}
              >
                {t("termsOfTravel.content")}
              </div>
            </article>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
